<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'Solicitacoes',
}

</script>



// WEBPACK FOOTER //
// src/components/solicitacoes/Solicitacao.vue